import { render, staticRenderFns } from "./FleetStatus.vue?vue&type=template&id=65c9882c"
import script from "./FleetStatus.vue?vue&type=script&lang=js"
export * from "./FleetStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports